import { DatePipe, DecimalPipe, I18nPluralPipe, registerLocaleData } from '@angular/common';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { AppBreadcrumbsService } from '@app/layout/breadcrumbs/services/app-breadcrumbs.service';
import { NotificationsService } from '@app/modules/notifications/notifications.service';
import { LANG_DICTIONARY_TOKEN, SERVER_URL_TOKEN } from '@constants/diConstant';
import { getDictionary, getServerUrl } from '@constants/factoryConstants';
import { LangService } from '@services/lang.service';
import { NotifierService } from '@services/notifier.service';
import { AppConfig } from '../app.config';
import { AppService } from '../app.service';
import { AuthGuard } from './auth.guard';
import { langLocale } from './material.module';
import { TokenStorage } from './token.storage';

/**
 * Инициализация локали
 * @param localeId ИД локали
 */
export const localeInitializer = (localeId: string): Promise<any> => {
    return import(`../../../node_modules/@angular/common/locales/${localeId}.mjs`).then((module) =>
        registerLocaleData(module.default, localeId),
    );
};

/**
 * Получение текущего языка
 */
export const getLanguage = (appService: AppService) => {
    return langLocale.indexOf(appService.currentLanguage) !== -1 ? appService.currentLanguage : 'ru';
};

/**
 * Инициализация конфига
 * @param config сервис получения конфига
 * @returns
 */
export const initConfigFactory = (config: AppConfig) => {
    return () => config.load();
};

@NgModule({
    providers: [
        AppConfig,
        AppService,
        LangService,
        AppBreadcrumbsService,
        NotifierService,
        NotificationsService,
        TokenStorage,
        { provide: APP_INITIALIZER, useFactory: initConfigFactory, deps: [AppConfig], multi: true },
        { provide: LOCALE_ID, useFactory: getLanguage, deps: [AppService] },
        { provide: SERVER_URL_TOKEN, useFactory: getServerUrl, deps: [AppService] },
        { provide: LANG_DICTIONARY_TOKEN, useFactory: getDictionary, deps: [AppService] },
        AuthGuard,
        DecimalPipe,
        DatePipe,
        I18nPluralPipe,
    ],
})
export class MainModule {}

/**
 * Инициализируем локаль сразу
 */
localeInitializer(
    window.localStorage.getItem('CurrentLang') && langLocale.indexOf(window.localStorage.getItem('CurrentLang')) !== -1
        ? window.localStorage.getItem('CurrentLang')
        : 'ru',
);
